module.exports = __webpack_public_path__ + "static/blackcurrant-6d323fa2b20f5b2d5f3c47711cfd3b80.svg";